import { useEffect, useState } from 'react';

import { useAuthenticatedApi } from './useAuthenticatedApi';
import { ensurePaddleInitialized, openTransactionCheckout } from '../lib/paddle';

/**
 * Initializes Paddle.js for authenticated users when the active provider is Paddle, and
 * auto-opens the checkout for a Paddle-initiated link (`?_ptxn=<transaction_id>` from an
 * invoice payment link, dunning email, or update-payment-method flow).
 *
 * The `_ptxn` value is captured on first render so a post-auth redirect can't strip it
 * before Paddle is ready. No-op when unauthenticated or when the provider is CityPay.
 */
export function usePaddleInit(): void {
  const api = useAuthenticatedApi();
  const [ptxn] = useState<string | null>(() =>
    typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('_ptxn') : null,
  );

  useEffect(() => {
    if (!api) return;
    let cancelled = false;

    ensurePaddleInitialized(api)
      .then((paddle) => {
        if (cancelled || !paddle) return;
        if (ptxn) openTransactionCheckout(paddle, ptxn);
      })
      .catch(() => {
        // Best-effort: checkout still initializes on demand in startCheckout.
      });

    return () => {
      cancelled = true;
    };
  }, [api, ptxn]);
}
